<template>
  <div>
    <div class="header2">
      <van-nav-bar
          title="问卷编辑"
          left-text="返回"
          left-arrow
          @click-left="goBack"
      />
    </div>
    <van-form @submit="onSubmit" class="form-sty">
      <van-field
          required
          v-model="title"
          name="title"
          label="问卷名称"
          placeholder="问卷名称"
          :rules="[{ required: true, message: '请填写调查名称' }]"
      />
      <van-field
          v-model="message"
          rows="5"
          autosize
          label="描述"
          type="textarea"
          placeholder="请输入问卷描述"
      />
      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit"
        >提交
        </van-button
        >
      </div>
    </van-form>
  </div>
</template>
<script>
import URL from '@/api/api'

export default {
  data() {
    return {
      titleData: {},
      backData: {},
      title: '',
      message: ''
    };
  },
  mounted() {
    this.titleData = this.$route.query.data
    this.title = this.titleData.title
    this.message = this.titleData.qaDesc
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    onSubmit() {
      let data={
          openId:localStorage.getItem("openid"),
          title:this.title,
          qaDesc:this.message,
          id:this.titleData.id
        }
      this.$fetchPost(URL.saveTitle.url, data).then(res => {
        if (res.data.code == 20000) {
          this.$router.push({path: '/editQuestionnaire/details', query: {typeId: this.titleData.id}});
        }
      })
    },
  },
};
</script>
<style scoped>
.van-cell {
  display: block;
}

.form-sty >>> .van-field__control {
  border: 1px solid #c0c4cc;
  border-radius: 5px;
  padding: 10px 5px;
}
</style>
